import { ProgressReview } from "../../../Models/ProgressReview";
// import { Promotion } from "../../../Models/Promotion";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";


export class ProgressReviewAPIHandler {
    
    public static shared = new ProgressReviewAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async getReviewById(reviewId: string): Promise<ProgressReview> {
        const response = await this.apiHandler.makeGetRequest(
            this.networkUtils.addAuthHeaders({}),
            this.serverConfig.ProgressReviewAPIs.getReviewByIdAPI(reviewId),
        );
        return new ProgressReview(response.data.review);
    }

    public async postReview(progressReviewData: any): Promise<ProgressReview> {
        let url = this.serverConfig.ProgressReviewAPIs.postReviewAPI;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            
            let response = await this.apiHandler.makePostRequest(authHeaders, url, progressReviewData);
            let data = response.data.review;
            let progressReview = new ProgressReview(data);
            return Promise.resolve(progressReview);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async askForProgressReview(orderId: string): Promise<string | undefined> {
        let url = this.serverConfig.ProgressReviewAPIs.askForProgressReviewAPI(orderId);
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            const response = await this.apiHandler.makePostRequest(authHeaders, url, {});
            return Promise.resolve(response.message);
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getReviewsForChannel(channelId: string): Promise<ProgressReview[]> {
        let url = this.serverConfig.ProgressReviewAPIs.getReviewsForChannelAPI(channelId);
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            let response = await this.apiHandler.makeGetRequest(authHeaders, url);
            let reviewsRes = response.data.reviews;
            const reviews = reviewsRes.map((item: any) => new ProgressReview(item))
            return Promise.resolve(reviews);
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getReviewsForOrder(orderId: string): Promise<ProgressReview[]> {
      let url = this.serverConfig.ProgressReviewAPIs.getReviewsForOrderAPI(orderId);
      let authHeaders = this.networkUtils.addAuthHeaders({});

      try {
          let response = await this.apiHandler.makeGetRequest(authHeaders, url);
          let reviewsRes = response.data.reviews;
          const reviews = reviewsRes.map((item: any) => new ProgressReview(item))
          return Promise.resolve(reviews);
      } catch (err) {
          return Promise.reject(err);
      }
  }
}